import React from 'react'
import { StyleSheet } from 'react-native'
import { createContainer } from '@dbk-legacy/muster/react'
import Modal from '@dbk/ui-modal'
import Text from '@dbk/ui-text'
import Button from '@dbk/ui-buttons'
import {
  PaymentMobileConfirmStep1,
  PaymentMobileConfirmStep2,
  PaymentMobileConfirmStep3,
} from '../../components/common/icons'
import styles from './payment-confirmation.styles'
// import { TIMER } from '../../constants'

// convert integer to 2 digit string
const digit2 = int => (int > 9 ? int : '0' + int)
// convert timestamp to "mm:ss"
const ts2mmss = ts => {
  const totalSeconds = Math.floor(ts / 1000)
  const s = totalSeconds % 60
  const m = (totalSeconds - s) / 60
  return digit2(m) + ':' + digit2(s)
}
const intervalCheck = (futureTimestamp, scheduleFn, forceCheck) => {
  const remainingMs = futureTimestamp - Date.now() // side-effect
  if (remainingMs < 0) forceCheck(true)
  else scheduleFn(remainingMs)
}

export class PaymentConfirmationModal extends React.PureComponent {
  state = {
    remainingMMSS: ts2mmss(this.props.payments.webTxnTimeout * 60000)
  }
  lsId = ''
  timerId = null
  scheduleFn = remainingMs => {
    const remainingMMSS = ts2mmss(remainingMs)
    this.setState({ remainingMMSS })
  }
  forceCheck = async timeout => {
    const isNewPayment = true
    await this.props.onRefresh()
    setTimeout(() => {
      const refreshStatus = this.props.refreshStatus
      let transState
      if (!refreshStatus) {
        if (timeout) {
          // fatal error, meaning no action from mobile and thus expires in web
          // * suppose to return { transState: "continue", validTime: false }
          this.props.onTimeout()
        } else {
          // fatal error, meaning something wrong in backend returning unexpected result
          this.props.cancelPayment(isNewPayment)
        }
      } else {
        transState = refreshStatus.transState
        if (transState === 'cancelled') {
          const cancelFromWeb = false
          this.props.cancelPayment(isNewPayment, false, cancelFromWeb)
        } else if (transState === 'submitted') {
          this.props.donePayment()
        } else if (timeout) {
          this.props.onTimeout()
        }
      }
      const stopTimer = timeout || !refreshStatus || transState !== 'continue'
      if (stopTimer) this.removeTimer()
    }, 100)
  }
  removeTimer = () => {
    // console.warn('remove localStorage Timer: ' + this.lsId);
    clearInterval(this.timerId)
    localStorage.removeItem(this.lsId)
  }

  componentDidMount() {
    const previousTimer = `pendingTxTimestamp_new`
    if (localStorage[previousTimer]) {
      localStorage.removeItem(previousTimer)
    }
    const orderId = this.props.orderId || 'new'
    this.lsId = `pendingTxTimestamp_${orderId}`
    if (!localStorage[this.lsId]) {
      localStorage[this.lsId] = Date.now() + this.props.payments.webTxnTimeout * 60000 + ''
    }
    const timeoutTs = localStorage[this.lsId]
    this.timerId = setInterval(
      () => intervalCheck(Number(timeoutTs), this.scheduleFn, this.forceCheck),
      1000
    )
    if(document.querySelector('button.btnRefreshFocus')){ // refresh button focusable 
      document.querySelector('button.btnRefreshFocus').focus();
    }
  }
  componentWillUnmount() {
    this.removeTimer()
  }

  render() {
    const { messages, onCancel } = this.props
    // const { remainingMMSS } = this.state
    return (
      <Modal
        testID="modal_confirmPayment_paymentConfirmationModal_test"
        isActive
        hideCloseButton
        disableOutsideClick
        title={messages['app.payment.pageTitle.paymentConfirmation']}
        className="modal-payment"
        header={messages['app.payment.pageTitle.paymentConfirmation']}
        size="large"
        content={
          <div>
            <div style={{ paddingLeft: '10%', paddingRight: '10%' }}>
              <span tabIndex={0} id="text_confirmPayment_paymentConfirmationModal_test" style={StyleSheet.flatten(styles.textHoldScreen)}>
                {messages['app.payments.confirmation.steps']}
              </span>
              {/* <span className="payment-timer">{remainingMMSS} {messages['app.payments.timerTxt']}</span> */}
            </div>
            <div className="payment-mobile-confirm-step">
              <div className="row">
                <div className="column small-12 medium-4" tabIndex={0}>
                  <div className="text-center">
                    <PaymentMobileConfirmStep1 width={65} height={65} />
                  </div>
                  <div className="text">
                    <Text secondary>{messages['app.payments.mobileConfirm.step1']}</Text>
                  </div>
                </div>
                <div className="column small-12 medium-4" tabIndex={0}>
                  <div className="text-center">
                    <PaymentMobileConfirmStep2 width={65} height={65} />
                  </div>
                  <div className="text">
                    <Text secondary>{messages['app.payments.mobileConfirm.step2']}</Text>
                  </div>
                </div>
                <div className="column small-12 medium-4" tabIndex={0}>
                  <div className="text-center">
                    <PaymentMobileConfirmStep3 width={65} height={65} />
                  </div>
                  <div className="text">
                    <Text secondary>{messages['app.payments.mobileConfirm.step3']}</Text>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div style={StyleSheet.flatten(styles.paymentBtnBlock)}>
                <div className="payment-btn">
                  <Button tertiary fullWidth onPress={onCancel}>
                    {messages['app.payments.cancelPayment']}
                  </Button>
                </div>
                <div className="payment-btn">
                  <Button tabInde={0} className="btnRefreshFocus" loading={this.props.payments.paymentRefresh.showSpinner} fullWidth onPress={() => this.forceCheck()}>
                    {messages['app.payments.refreshPayment']}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        }
      />
    )
  }
}

export default createContainer({
  $queries: {
    i18n: { messages: true },
    changePage: { $call: 'ui.history.push' },
    payments: {
      initializeTx: { $call: 'initializeTx' },
      cancelTx: { $call: 'cancelTx' },
      paymentType: true,
      webTxnTimeout: true,
      paymentRefresh: { showSpinner: true }
    },
  },
})(PaymentConfirmationModal)